/**
 * The locale is pinned rather than taken from the browser, for the same reason
 * the workspace date is: the panel is a fixed-width column, and a locale that
 * lengthens "2 min ago" into a phrase wraps every row in the list.
 */
const LOCALE = 'en-US'

const relative = new Intl.RelativeTimeFormat(LOCALE, { numeric: 'auto', style: 'narrow' })
const absolute = new Intl.DateTimeFormat(LOCALE, { day: 'numeric', month: 'short' })

const MINUTE = 60_000
const HOUR = 60 * MINUTE
const DAY = 24 * HOUR

/**
 * "just now" · "5 min ago" · "3 hr ago" · "yesterday" · "12 Aug".
 *
 * Past the week mark a relative phrase stops being informative — "4 wk ago" is
 * harder to place than the date itself — so it hands over to an absolute one.
 */
export function formatNoticeTime(iso: string, now: Date): string {
  const at = new Date(iso)
  if (Number.isNaN(at.getTime())) return ''

  const elapsed = now.getTime() - at.getTime()

  // A clock that is behind the server would otherwise render "in 2 min" on a
  // notice that has already happened.
  if (elapsed < MINUTE) return 'just now'
  if (elapsed < HOUR) return relative.format(-Math.floor(elapsed / MINUTE), 'minute')
  if (elapsed < DAY) return relative.format(-Math.floor(elapsed / HOUR), 'hour')
  if (elapsed < 7 * DAY) return relative.format(-Math.floor(elapsed / DAY), 'day')

  return absolute.format(at)
}
